import { axiosInstance } from './config/instance'
import { CONSOLE_API_URL, SERVER } from './config/url'

const BLACK_LIST_URL = `${SERVER}/${CONSOLE_API_URL}`
const ENTITY = 'black_list'

export const blackList = Object.freeze({
  async fetchList(params) {
    const response = await axiosInstance.get(`${BLACK_LIST_URL}/${ENTITY}`, { params })
    return response.data
  },
  async add(data) {
    const response = await axiosInstance.post(`${BLACK_LIST_URL}/${ENTITY}/add`, data)
    return response.data
  },
})
